import React from 'react';
import map from 'lodash/map';
import createReactClass from 'create-react-class';

import formActions from '../../actions/form-actions';
import mapActions from '../../actions/map-actions';

export default createReactClass({
	handleSubmit: function (e) {
		e.preventDefault();
		e.stopPropagation();
	},

	handleClick: function (e) {
		const selectedItem = e.target;
		const name = selectedItem.getAttribute('data-name');
		const filter = selectedItem.value;
		formActions.selectFilter(name, filter);
		process.nextTick(() => mapActions.zoomOut());
	},

	handleToggleVegetarian: function (
		/** @type {React.ChangeEvent<HTMLInputElement>} */ e
	) {
		const selectedItem = e.target;
		if (selectedItem.checked) {
			const name = selectedItem.getAttribute('data-name');
			const filter = selectedItem.value;
			formActions.selectAdditionalFilter(name, filter);
		} else {
			formActions.selectAdditionalFilter(null, null);
		}
		process.nextTick(() => mapActions.zoomOut());
	},

	render: function () {
		const filters = this.props.categoryFilters;

		const options = map(filters, (ids, name) => (
			<li key={name}>
				<button
					role="button"
					value={JSON.stringify(ids)}
					data-name={name}
					onClick={this.handleClick}
					aria-selected={this.props.selectedFilterOptionName === name}
					className={
						'bssp-filter-selector__button ' +
						(this.props.selectedFilterOptionName === name
							? 'bssp-filter-selector__button--active'
							: '')
					}
				>
					{name}
				</button>
			</li>
		));

		return (
			<form onSubmit={this.handleSubmit}>
				<ul>
					<li>
						<button
							className="bssp-filter-selector__button"
							value=""
							onClick={this.handleClick}
						>
							- Alle Stände -
						</button>
					</li>
					{options}
				</ul>

				{map(this.props.additionalCategoryFilters, (ids, name) => (
					<label
						key={name}
						className="bssp-filter-selector__additional-option"
					>
						<input
							type="checkbox"
							name="additional-filter"
							value={JSON.stringify(ids)}
							data-name={name}
							checked={
								this.props
									.selectedAdditionalFilterOptionName === name
							}
							onChange={this.handleToggleVegetarian}
						/>
						{' ' + name}
					</label>
				))}
			</form>
		);
	},
});
